import React, { useState } from 'react';
import { X, Send } from 'lucide-react';
const Newsletter = ({
  onClose
}) => {
  const [email, setEmail] = useState('');
  const [submitted, setSubmitted] = useState(false);
  const handleSubmit = e => {
    e.preventDefault();
    // In a real app, you would submit the email to a backend
    setSubmitted(true);
    setTimeout(() => {
      onClose();
    }, 2000);
  };
  return <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50 p-4" data-id="element-469">
      <div className="bg-white rounded-lg shadow-xl max-w-md w-full relative overflow-hidden" data-id="element-470">
        <button onClick={onClose} className="absolute top-4 right-4 text-gray-500 hover:text-gray-700" data-id="element-471">
          <X size={20} data-id="element-472" />
        </button>
        <div className="p-6 md:p-8" data-id="element-473">
          {!submitted ? <>
              <div className="flex justify-center mb-6" data-id="element-474">
                <div className="bg-navy-100 p-4 rounded-full" data-id="element-475">
                  <Send size={32} className="text-navy-900" data-id="element-476" />
                </div>
              </div>
              <h3 className="text-2xl font-bold text-center text-navy-900 mb-2" data-id="element-477">
                Subscribe to our Newsletter!
              </h3>
              <p className="text-center text-navy-700 mb-6" data-id="element-478">
                Stay updated with our latest travel packages, promotions and
                travel tips.
              </p>
              <form onSubmit={handleSubmit} data-id="element-479">
                <div className="mb-4" data-id="element-480">
                  <input type="email" placeholder="Your email address" value={email} onChange={e => setEmail(e.target.value)} className="w-full px-4 py-3 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-gold-500" required data-id="element-481" />
                </div>
                <button type="submit" className="w-full bg-navy-900 hover:bg-navy-800 text-white px-4 py-3 rounded-md font-medium transition-colors" data-id="element-482">
                  Subscribe
                </button>
              </form>
              <p className="text-xs text-center text-navy-600 mt-4" data-id="element-483">
                By subscribing, you agree to receive marketing emails from us.
                You can unsubscribe at any time.
              </p>
            </> : <div className="py-8 text-center" data-id="element-484">
              <div className="flex justify-center mb-6" data-id="element-485">
                <div className="bg-green-100 p-4 rounded-full" data-id="element-486">
                  <Send size={32} className="text-green-500" data-id="element-487" />
                </div>
              </div>
              <h3 className="text-2xl font-bold text-navy-900 mb-2" data-id="element-488">
                Thank You!
              </h3>
              <p className="text-navy-700" data-id="element-489">
                You've successfully subscribed to our newsletter.
              </p>
            </div>}
        </div>
      </div>
    </div>;
};
export default Newsletter;